import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng';
import { BBWTMessageService } from '../../services/message.service';
import { MobileLoggingService } from '../../services/mobile-logging.service';
import { UserService } from './../../services/user.service';

@Component({
  selector: 'mobile-logging',
  templateUrl: './mobile-logging.component.html',
})
export class MobileLoggingComponent implements OnInit {
  userIds: string[] = [];
  users: SelectItem[];
  subject = 'Mobile Logging';

  constructor(
    private mobileLoggingService: MobileLoggingService,
    private userService: UserService,
    public messageService: BBWTMessageService,
  ) {}

  ngOnInit() {
    this.userService
      .getMobileUsers()
      .then((users) => {
        this.users = users.map((u) => <SelectItem>{ label: u.userName, value: u.id });
        this.userIds = users.filter((u) => u.enableMobileLogging).map((u) => u.id);
      })
      .catch((errorResponse: HttpErrorResponse) => {
        var message = errorResponse.error ? errorResponse.error : errorResponse.message;
        this.messageService.ShowError(this.subject, message);
      });
  }

  update() {
    this.mobileLoggingService
      .update(this.userIds)
      .then(() => {
        this.messageService.ShowSuccess(this.subject, 'Updated.');
      })
      .catch((errorResponse: HttpErrorResponse) => {
        var message = errorResponse.error ? errorResponse.error : errorResponse.message;
        this.messageService.ShowError(this.subject, message);
      });
  }
}
